







































import { CardByBoard } from "@/dataService";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation } from "vuex-class";
import { board, card } from "../board";
import Card from "./Card.vue";

const ESC_KEY_CODE = 27;

@Component({
  components: {
    Card,
  },
})
export default class Board extends Vue {
  @Action private createCard;
  @Action private deleteBoard;
  @Action private updateCardByBoard: (card: CardByBoard) => any;
  @Prop() private board!: board;
  @Mutation updateBoardWithCardIndex;
  @Mutation("removeBoard") removeBoardWithId;
  private isNewCardInputVisible = false;
  private isBoardHovered = false;
  private newCardTitle = "";

  public toggleNewCardInput() {
    this.isNewCardInputVisible = !this.isNewCardInputVisible;
    if (this.isNewCardInputVisible) {
      this.$nextTick(() => {
        (this.$refs.contentTextArea as HTMLElement).focus();
      });
    }
  }

  public toggleBoardHover() {
    this.isBoardHovered = !this.isBoardHovered;
  }

  public removeBoard() {
    this.deleteBoard(this.board);
    this.removeBoardWithId(this.board._id);
  }

  public addNewCardToBoard() {
    if (this.newCardTitle !== "") {
      const newCard = {
        board: this.board._id,
        comments: [],
        title: this.newCardTitle.trim(),
        description: "",
        picture: "",
        createdOn: new Date(),
        dueOn: new Date(),
      };
      this.createCard(newCard);
      this.newCardTitle = "";
    }
  }

  public drop(e) {
    const cardId = e.dataTransfer.getData("card_id");
    const cardDragged = JSON.parse(e.dataTransfer.getData("dragged_card")) as card;
    console.log(cardId);
    console.log(JSON.stringify(cardDragged));
    const dropYPosition = e.pageY;
    let isBoardUpdated = false;
    for (let i = 0; i < this.board.cards.length; i++) {
      const cardYPosition = document.getElementById(this.board.cards[i]._id);
      if (
        cardYPosition &&
        cardYPosition.getBoundingClientRect().y > dropYPosition
      ) {
        this.updateCardByBoard({
          card: cardDragged,
          newBoard: this.board,
          boardInsertIndex: i,
        });
        this.updateBoardWithCardIndex({
          cardId,
          destBoardId: this.board._id,
          destIndex: i,
        });
        isBoardUpdated = true;
        break;
      }
    }
    if (!isBoardUpdated) {
      this.updateCardByBoard({
        card: cardDragged,
        newBoard: this.board,
        boardInsertIndex: this.board.cards.length,
      });
      this.updateBoardWithCardIndex({
        cardId,
        destBoardId: this.board._id,
        destIndex: this.board.cards.length,
      });
    }
  }

  mounted() {
    window.addEventListener("keyup", (e) => {
      if (e.keyCode === ESC_KEY_CODE) {
        this.isNewCardInputVisible = false;
      }
    });
  }
}
